import { useEffect, useRef } from "react";
import { isTextEntryTarget } from "src/domains/shared/utils/textEntryTarget";

/**
 * 그리기 도구가 활성인 동안 document 의 Escape 키를 취소 신호로 받는다.
 * 텍스트 입력 요소에 포커스가 있을 때의 Escape 는 지도 도구가 가로채지 않는다(`isTextEntryTarget`).
 */
export function useDrawingCancelKey(active: boolean, onCancel: () => void) {
  const onCancelRef = useRef(onCancel);
  useEffect(() => {
    onCancelRef.current = onCancel;
  });

  useEffect(() => {
    if (!active) return;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== "Escape") return;
      if (isTextEntryTarget(event.target)) return;
      onCancelRef.current();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [active]);
}
